import { BaseApi } from '@/main/baseApi';

import { DMS_MODULE, NAME, DependentTableNames, POLOZKY, PR_INVOICE } from './constants';

export const prijemkaTiskUrl = '/Reports/Reports/GetPrijemkaNdReport';
export const partsPurInvoiceUrl = '/Servis/Reports/GetPartsPurchaseInvoiceReport';

export class PRInvoiceProvider extends BaseApi {
	schemaUrl(tableName: DependentTableNames) {
		switch (tableName) {
			case POLOZKY:
				return `/${this.area}/${NAME}/GRNItemsSchema`;
			case PR_INVOICE:
				return `/${this.area}/${NAME}/SelectSchema`;
			default:
				throw new Error(`schema for ${tableName} is not implemented yet`);
		}
	}

	tableUrl(tableName: DependentTableNames) {
		switch (tableName) {
			case POLOZKY:
				return `/${this.area}/${NAME}/GRNItemsRows`;
				case PR_INVOICE:
					return `/${this.area}/${NAME}/SelectRows`;
			default:
				throw new Error(`schema for ${tableName} is not implemented yet`);
		}
	}

	savePRInvoicePayment(dto: any) {
		return this.post(`/${DMS_MODULE}/${NAME}/SavePRInvoicePayment`, dto);
	}
	saveGRNParts(dto: any) {
		return this.post(`/${DMS_MODULE}/${NAME}/SavePrReceipt`, dto);
	}
	savePartsList(dto: any, recieptList: any[]) {
		return this.fetch(`/${DMS_MODULE}/${NAME}/SaveMultipleReceipt`,
		{
			PRReceipt: dto,
			recieptList: recieptList
		});
	}

	markReportAsPrinted(id: number, reportType: string) {
		return this.post(`/Servis/Zakazka/MarkAsPrint?id=${id}&reportType=${reportType}`);
	}

	async prInvoiceClick(filter: any) {
		return this.post(`/${DMS_MODULE}/${NAME}/PRInvoiceClick`, filter);
	}
	async prInvoiceFiler() {
		return this.fetch(`/${DMS_MODULE}/${NAME}/Filter`);
	}
	CheckPRInvoiceExists(dto: any) {
	return this.post(`/${DMS_MODULE}/${NAME}/CheckPRInvoiceExists`, dto);
}
}

export const apiProvider = new PRInvoiceProvider(DMS_MODULE, NAME);
